import React, {  useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from "react-router-dom";
import Loading from 'components/Loading';
import './style.scss';
import TermPolCheckbox from 'components/TermPolCheckbox';
import LoginService from 'services/Login/service';
import { types } from '../../types/types';
import SessionFactory from 'factories/Session';
import { AuthContext } from '../../auth/AuthContext';

const PopupUpdateUser= ({ execActionConfirm = null, titleText = "", popupLegalText = "" ,loginData=""}) => {

    const { sessionDispatch } = useContext(AuthContext);
    const [privacyPoliciesChecked, setPrivacyPoliciesChecked] = useState(loginData.loginApp.privacyPolicies);
    const [termConditionsChecked, setTermConditionsChecked] = useState(loginData.loginApp.termConditions);
    const [legalOthersChecked, setLegalOthersChecked] = useState(loginData.loginApp.legalOthers);
    //const [privacyPoliciesChecked, setPrivacyPoliciesChecked] = useState(true);
    //const [termConditionsChecked, setTermConditionsChecked] = useState(true);
    //const [legalOthersChecked, setLegalOthersChecked] = useState(true);
    const [selectedDocumentType, setSelectedDocumentType] = useState(
        loginData && loginData.loginApp && loginData.loginApp.documentType
    ); // Nuevo estado para el tipo de documento
    const [isLoading, setIsLoading] = useState(false);

    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);

    const decodificarBase64 = (cadenaBase64) => {
        if (!cadenaBase64) return null; // Si la cadena es nula, devolver nulo

        try {
            // Intentar decodificar la cadena Base64
            return atob(cadenaBase64);
        } catch (error) {
            // Capturar cualquier error y manejarlo
            return null; // Otra opción sería lanzar una excepción o devolver un valor por defecto
        }
    }

    const documentNumberParam = decodificarBase64(searchParams.get("dn"));

    const [documentNumber, setDocumentNumber] = useState(
        loginData && loginData.loginApp && (documentNumberParam ? documentNumberParam : loginData.loginApp.documentNumber)
    );

    //useEffect(() => {
      // console.log(loginData,"loginData de popup");
    //}, []);
  


    
    const handleConfirm = (event) => {
        execActionConfirm && execActionConfirm(event);
    }
  
    

    const updateUser=()=>{
        try{
            setIsLoading(true);
            const iniciotimeSession=new Date();

            //update user
            Promise.all([LoginService.updateUserValidation({
                'jwt':loginData.login,
                'documentCode':selectedDocumentType,// Enviar el valor seleccionado del tipo de documento
                'documentNumber':documentNumber,
                'privacyPolicies':privacyPoliciesChecked,
                'termConditions':termConditionsChecked,
                'legalOthers':legalOthersChecked,
                'userAwsType':loginData.loginApp.userAwsType

            }),
            ]).then(([auth]) => {
                 
                setIsLoading(false);
                handleConfirm();
                let authenticatedUser=SessionFactory.authenticatedUserJwt(auth.payload.jwt);
                SessionFactory.saveUpdateTries(authenticatedUser,'update');

                if( ['200','201'].includes(auth.internalCode) && (!authenticatedUser.validateUserByDni)) {
                    console.log("validateUserByDni");
                    return;
                }
                
                sessionDispatch({
                    type: types.login,
                    payload: SessionFactory.initialize(loginData.loginApp.additionalFields.jwt, "", iniciotimeSession,"username")
                });
                
              })
              .catch(error=>{
                console.error(error);
                setIsLoading(false);
            });

        }catch(error){
            console.error(error);
        }
    };
    
    

    return (
        <div className="white-popup message-popup-simple account-update">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <p className="text-center mb-4 red">
                                    <strong>{titleText}</strong>
                                </p>
                                <div className="mb-4">
                                    {popupLegalText !== "" ? (
                                        <>
                                            <div className="row">
                                                <div className="col-12 col-lg-6">
                                                    <div className="form-group">
                                                     <label>Tipo de Documento</label>
                                                     <select
                                                       value={selectedDocumentType}
                                                       onChange={(e) => setSelectedDocumentType(e.target.value)}
                                                       disabled={loginData && loginData.loginApp && loginData.loginApp.documentType}
                                                       className='form-control'
                                                      >
                                                       <option value=""  >Seleccione...</option>
                                                       <option value="1" >DNI</option>
                                                       <option value="4" >Pasaporte</option>
                                                       <option value="5" >RUC</option>
                                                       <option value="2" >CI</option>
                                                       <option value="3" >CE</option>
                                                       <option value="9" >Sin-Doc-Id</option>
                                                       <option value="0" >Otros</option>
                                                       {/* Agrega más opciones según sea necesario */}
                                                     </select>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-6">
                                                    <div className="form-group">
                                                        <label>
                                                            N° Documento 
                                                        </label>
                                                        <input
                                                            value={documentNumber || ""}
                                                            onChange={(e) => setDocumentNumber(e.target.value) }
                                                            required
                                                            maxLength="50"
                                                            type="text"
                                                            className="form-control"
                                                            name="textBoxDocumento"
                                                            id="textBoxDocumento"
                                                            readOnly={
                                                                !selectedDocumentType || 
                                                                (loginData && loginData.loginApp && loginData.loginApp.documentNumber !== null && loginData.loginApp.documentNumber !== '')
                                                            }
                                                            placeholder="N° Documento"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12 col-lg-6">
                                                    <div className="form-group">
                                                        <label>Nombres</label>
                                                        <input
                                                            value={(loginData && loginData.loginApp && (loginData.loginApp.firstName && loginData.loginApp.firstName.toUpperCase()!="NULL")?loginData.loginApp.firstName:"") || ""}
                                                            readOnly={true}
                                                            required
                                                            maxLength="50"
                                                            type="text"
                                                            className="form-control"
                                                            name="textBoxNombres"
                                                            id="textBoxNombres"
                                                            placeholder="Nombres"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-6">
                                                    <div className="form-group">
                                                        <label>Apellidos</label>
                                                        <input
                                                            value={(loginData && loginData.loginApp && (loginData.loginApp.lastName && loginData.loginApp.lastName.toUpperCase()!=="NULL")?loginData.loginApp.lastName:"") ||""}
                                                            readOnly={true}
                                                            required
                                                            maxLength="50"
                                                            type="text"
                                                            className="form-control"
                                                            name="textBoxApellidos"
                                                            id="textBoxApellidos"
                                                            placeholder="Apellidos"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 col-lg-6">
                                                    <div className="form-group">
                                                        <label>Correo</label>
                                                        <input
                                                            value={(loginData && loginData.loginApp && (loginData.loginApp.email && loginData.loginApp.email.toUpperCase()!=="NULL")?loginData.loginApp.email:"")||""}
                                                            readOnly={true}
                                                            required
                                                            maxLength="50"
                                                            type="text"
                                                            className="form-control"
                                                            name="textBoxNombres"
                                                            id="textBoxNombres"
                                                            placeholder="Correo"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-6">
                                                    <div className="form-group">
                                                        <label>Telefono</label>
                                                        <input
                                                            value={(loginData && loginData.loginApp && (loginData.loginApp.phone && loginData.loginApp.phone.toUpperCase()!=="NULL")?loginData.loginApp.phone:"") || ""}
                                                            readOnly={true}
                                                            required
                                                            maxLength="50"
                                                            type="text"
                                                            className="form-control"
                                                            name="textBoxApellidos"
                                                            id="textBoxApellidos"
                                                            placeholder="Telefono"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                       
                                       

                                       
                                           
                                           <div className="col-12 ml-lg-auto mr-lg-auto mt-lg- mt-3">
                                           <TermPolCheckbox textId = "terminos"   value={privacyPoliciesChecked} setValue={setPrivacyPoliciesChecked} showToolip={true}
                                           disableCheck={privacyPoliciesChecked}/>
                                           </div>
                                           
                                           <div className="col-12 ml-lg-auto mr-lg-auto mt-lg- mt-3">
                                           <TermPolCheckbox textId = "politica"   value={termConditionsChecked} setValue={setTermConditionsChecked} showToolip={true}
                                           disableCheck={termConditionsChecked}/>
                                           </div>
                                           <div className="col-12 ml-lg-auto mr-lg-auto mt-lg- mt-3">
                                           <TermPolCheckbox textId = "legal-others"   value={legalOthersChecked} setValue={setLegalOthersChecked} />
                                           </div>
                                          
                                       
                                       
                                       
                                      {/*  <div className="col-12 col-lg-9 ml-lg-auto mr-lg-auto mt-lg-4 mt-3">
                                       {visibleLegalSocialTooltip[2] &&<MsgError msg="*opcional*"  />}
                                       <TermPolCheckbox textId = "data-protection" handlegetValueCheked={handleDisButtSocAut} />
                                       
                                       </div> */}
            
                                         
                                   
                                        </>
                                    ) : (
                                        <Loading type="size-xs" />
                                    )}
                                </div>
                                <div className="text-center">
                                    <a
                                        href="#"
                                        onClick={updateUser
                                            
                                        }
                                        className="btn"
                                        id="a-confirm"
                                    >
                                        {isLoading? <Loading type='wong--hover'/>:'Guardar'}
                                        
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PopupUpdateUser.propTypes = {
    execActionConfirm: PropTypes.func, 
    popupLegalText: PropTypes.string,
    titleText: PropTypes.string,
    loginData:PropTypes.object

};
export default PopupUpdateUser;
